// Shown after files are staged, before evaluation begins.
// User selects what they're optimizing for, which adjusts
// how the scoring dimensions are weighted.

import React, { useState } from 'react';
import type { Priority, Theme } from '../types';
import { PRIORITY_OPTIONS } from '../utils/formatters';
import ThemeToggle from './ThemeToggle';
import priorityStyles from '../styles/PrioritySelector.module.css';

interface PrioritySelectorProps {
  files: File[];
  onSubmit: (priority: Priority) => void;
  onBack: () => void;
  theme: Theme;
  onToggleTheme: () => void;
}

export default function PrioritySelector({
  files,
  onSubmit,
  onBack,
  theme,
  onToggleTheme,
}: PrioritySelectorProps) {
  const [selected, setSelected] = useState<Priority>('honest');

  const label = files.length === 1
    ? files[0].name
    : `${files.length} papers selected`;

  return (
    <div className={priorityStyles.page}>
      <div className={priorityStyles.container}>
        <h1 className={priorityStyles.title}>One quick question</h1>
        <p className={priorityStyles.subtitle}>
          What are you looking for? We'll weight the evaluation accordingly.
        </p>
        <span className={priorityStyles.filename}>{label}</span>

        <div className={priorityStyles.options}>
          {PRIORITY_OPTIONS.map(opt => (
            <div
              key={opt.value}
              onClick={() => setSelected(opt.value)}
              className={`${priorityStyles.option} ${
                selected === opt.value ? priorityStyles.optionSelected : ''
              }`}
            >
              <div className={priorityStyles.optionLabel}>{opt.label}</div>
              <div className={priorityStyles.optionDesc}>{opt.description}</div>
            </div>
          ))}
        </div>

        <div className={priorityStyles.buttons}>
          <button className={priorityStyles.btnBack} onClick={onBack}>
            ← Back
          </button>
          <button
            className={priorityStyles.btnEvaluate}
            onClick={() => onSubmit(selected)}
          >
            Evaluate →
          </button>
        </div>
      </div>
      <ThemeToggle theme={theme} onToggle={onToggleTheme} />
    </div>
  );
}